<template>
  <div>
	<!-- <el-select @change="change" style="width: 100%"  size="small" v-model="value"  placeholder="请选择" >
		<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
		</el-option>
	</el-select> -->
	<el-cascader :props="{checkStrictly: true,label:'name',value:'id'}"
	    v-model="value" size="small" placeholder="请选择师傅分类"
	    :options="options" style="width: 100%"
	    @change="change"></el-cascader>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    modelValue: {
      type: [String, Number], // 根据你传递的类型，修改这里的类型
      default: "",
    },
	vals:{
		type:Number,
		default:""
	}
  },
  data() {
    return {
      value: [],
      options: [],
    };
  },
  created() {
    // 获取商品分类列表
    this.getCategoryList();
  },
  methods: {
    change() {
		console.log('this.value',this.value)
      this.$emit("getValue", this.value[this.value.length-1]);
    },
    getCategoryList() {
      let _this = this;
      _this.axios.get("/api/weishop/admin/plugin/staff/cat/index").then((res) => {
        if (res.code == 200) {
          _this.options = res.data.data
        } else {
          eltips(res.msg, "error");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped></style>
